// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qd-5";
export var filledCircle = "_qd-4";
export var historyEntry = "_qd-3";
export var messageSideLeft = "_qd-1";
export var messageSideRight = "_qd-2";
export var orderTrackingCarouselWrapper = "_qd-6";
export var orderTrackingInfoContainer = "_qd-0";